import { render, staticRenderFns } from "./SalesAndProfitChart.vue?vue&type=template&id=f30ce6d4&scoped=true&lang=pug&"
import script from "./SalesAndProfitChart.vue?vue&type=script&lang=js&"
export * from "./SalesAndProfitChart.vue?vue&type=script&lang=js&"
import style0 from "./SalesAndProfitChart.vue?vue&type=style&index=0&id=f30ce6d4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f30ce6d4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
installComponents(component, {VBtn,VCard,VCol,VDivider,VRow,VTab,VTabs})
